<footer>
    <div class="row">
        <div class="col-xs-12 footer__logo-bar">
            <img src="assets/images/binaryfractal.png" alt="binaryfractal">&nbsp;
            <a href="https://binaryfractal.com" target="_blank">Powered by binaryfractal</a>
        </div>
    </div>
</footer>
